import Link from 'next/link';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getFAQLink } from '@/helpers/utils/siteUtils';

const PhoneNumberTooltip = () => {
  return (
    <section>
      <p className="pb-3 text-sm font-semibold leading-5">{mapLocaleToMeaningfulFormat().phoneNumber}</p>
      <p className="pb-3">
        {mapLocaleToMeaningfulFormat().phoneTooltipText}
        <Link
          target="_blank"
          prefetch={false}
          href={getFAQLink('/help-center/faq/privacy-policy')}
          className="text-black underline"
        >
          {mapLocaleToMeaningfulFormat().privacyPolicyPage}
        </Link>
        .
      </p>
    </section>
  );
};

export default PhoneNumberTooltip;
